const env = require("services/env");
const global = global || window;
const Stripe = global.Stripe;

function createStripe() {
	return env.has("options.stripe.key") && typeof Stripe === "function" ?
		Stripe(env.get("options.stripe.key")) :
		null;
}

module.exports = createStripe();


// WEBPACK FOOTER //
// ./resources/js/services/stripe.js